<template>
	<div class="basic_wrap">
		<div class="backgroud_bg">
			<img src="../images/index/red_bg_1.png" alt="" style="width: 100%;">
		</div>
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
		</div>
		<!-- 输入框 -->
		<div class="input_tab">
			<div class="backgroud_bg" v-if="type == 1">
				<img src="../images/index/gr-h2.png"  v-if="userlevel >= level" alt="" style="width: 100%;">
				<img src="../images/index/gr-h.jpg" v-else alt="" style="width: 100%;">
			</div>
			<div class="backgroud_bg" v-if="type == 2">
				<img src="../images/index/jt-h2.png"  v-if="userlevel >= level" alt="" style="width: 100%;">
				<img src="../images/index/jt-h.jpg" v-else alt="" style="width: 100%;">
			</div>
			<div class="diploma_centent">
				<div class="diploma_left">
					<div class="diploma_header">
						<div class="honour_time" v-if="type == 2">{{createtime}}</div>
					</div>
					<div class="diploma_footer">
						<img src="../images/index/zhang.png" alt="" style="width: 100%;opacity: 0.4;">
					</div>
				</div>
				<div class="diploma_right">
					<div class="user_name" :class="type == 1?'user_name_top':'' ">{{nickname}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index";

	export default {
		name: "Information",
		components: {},
		data() {
			return {
				data: {},
				type:1,
				userlevel:0,
				level:12,
				createtime:'',
				nickname:'',
			};
		},
		created() {
			this.userlevel = localStorage.getItem('login_userlevel');
			this.createtime = localStorage.getItem('login_createtime');
			this.nickname = localStorage.getItem('login_usernickname');
			
			this.createtime = this.formattedDate(this.createtime)
			this.$parent.footer('info', false);
			if (this.$router.history.current.query.type) {
				this.type = parseInt(this.$router.history.current.query.type);
			}
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				
			},
			changeInputBox(obj){
				if(obj == 1){
					this.box1 = false;
					this.box2 = true;
				}else if(obj == 2){
					this.box2 = false;
					this.box3 = true;
				}else if(obj == 3){
					this.box3 = false;
					this.box4 = true;
				}else if(obj == 4){
					this.$router.push('/infoResult');
				}
			},
			formattedDate(timestamp) {
			  const date = new Date(timestamp);
			  const year = date.getFullYear();
			  const month = ('' + (date.getMonth() + 1)).slice(-2); // 月份是从0开始的
			  const day = ('' + date.getDate()).slice(-2);
			  return year + '-' + month + '-' + day;
			},
		},
	};
</script>

<style lang="less" scoped>
	.red_top_bg{
	    position: fixed;
	    top: 0;
	    z-index: 10;
		background-image:none;
		
		.back_left {
			background: url(../../views/images/back_b.png) no-repeat center center;
		}
		.big_tit{
			color: #ffffff;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 1;
			overflow: hidden;
		}
	}
	.backgroud_bg{
		position: absolute;
		z-index: 1;
		top: 0;
		left: 0;
	}
	.input_tab {
	    position: absolute;
	    width: 100%;
	    z-index: 9;
	    top: 10vh;
		
		.diploma_centent {
		    position: relative;
		    z-index: 9;
		    display: flex;
		    justify-content: center;
			
			.diploma_left {
			    position: relative;
			    z-index: 9;
			    width: 2rem;
			    left: -2rem;
				
				.diploma_header {
				    position: relative;
				    margin: 0 auto;
				    font-size: 0.5rem;
				    margin-top: 2rem;
					height: 3rem;
					
					.honour_time{
						writing-mode: vertical-rl;
						    position: relative;
						    left: 70%;
					}
				}
				.diploma_footer {
				    margin-top: 6rem;
				}
			}
			.diploma_right {
			    left: 0.5rem;
			    position: relative;
				    width: 1rem;
					z-index: 9;
				
				.user_name{
					position: relative;
					top: 50%;
					font-size: 0.5rem;
					transform: rotate(90deg);
					width: 3rem;
					left: -1.2rem;
				}
				.user_name_top{
					top: 60% !important;
				}
			}
		}
	}
	
</style>
